import BaseModel from "../BaseModel";
import NoteType from "./NoteType";

export default class Note extends BaseModel{
    static entity = 'notes';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            note: this.attr(null),
            note_type_id: this.attr(null),
            user_id: this.attr(null),
            note_type: this.belongsTo(NoteType, 'note_type_id'),
            created_by: this.attr(null),
            created_at: this.attr(null)
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'note_type']
    }
    static route(){
        return '/notes'
    }
}
